import './Layout.scss';
import { Header, HeaderMob } from './Header/HeaderMob';
// import { Footer } from './Footer/Footer';
import { NavBar } from './NavBar/NavBar';
import { useState } from 'react';
import { HeaderWeb } from './Header/HeaderWeb';
// import { Header3 } from './Header/Header3';
// import { HeaderContent } from './Header/Header3Content';
import { HeaderContext } from '../Contexts/HeaderContext';
import { SearchMobHeader } from './Header/SearchMobHeader';
import { SearchMobHeaderContent } from './Header/SearchMobHeaderContent';
import { isMobile } from 'react-device-detect';
import { Footer } from './Footer/Mob/Footer';
import { ContentContainer } from '../content-container/ContentContainer';
import { CheckoutPathTracker } from '../hooks/CheckoutPathTracker';
function Layout({ children }) {

    const [headerToggle, setHeaderToggle] = useState(false)
    // const [headerBack, setHeaderBack] = useState(false)
    const [selectedHeader, setSelectedHeader] = useState(() => (isMobile ? 2 : 1))
    const [headerBack, setHeaderBack] = useState(true)

    return (
        // <div className="Layout" style={{overflowX: 'hidden'}}>
        <HeaderContext.Provider value={{ headerBack, setHeaderBack }}>
            <CheckoutPathTracker />
            <div className="Layout">
                {selectedHeader === 1 ? < HeaderWeb headerToggle={headerToggle} setHeaderToggle={setHeaderToggle} />
                    : selectedHeader == 2
                        ?
                        <>
                            < NavBar headerToggle={headerToggle} setHeaderToggle={setHeaderToggle} />
                            < HeaderMob headerToggle={headerToggle} setHeaderToggle={setHeaderToggle} setSelectedHeader={setSelectedHeader} />
                        </>
                        : selectedHeader == 3
                            ?
                            <>
                                {/* < SearchMobHeader /> */}
                                < SearchMobHeaderContent setSelectedHeader={setSelectedHeader} />
                            </>
                            :
                            null
                }
                    {/* <main style={selectedHeader !== 1 ? { paddingTop: '10.7rem' } : { paddingTop: '56px' }}>{children}</main> */}
                    < ContentContainer children={children} selectedHeader={selectedHeader} />
                {/* < Footer /> */}
            </div >
        </HeaderContext.Provider >

    );
}

export default Layout;
